const TypePrefix = "menu/";

export const Types = {
  LOAD_MENU: TypePrefix + "LOAD_MENU",
  SET_FETCH: TypePrefix + "SET_FETCH",
  SET_PERMISSION: TypePrefix + "SET_PERMISSION",
};
